






















import { defineComponent, ref, watch } from '@vue/composition-api';
import { useCategory } from '@/bundles/Category/composables/useCategory';
import { usePagination } from '@/bundles/BaseTable/composables/usePagination';
import CategoryListTable from '@/bundles/Category/components/CategoryListTable.vue';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { ICategory } from '@/bundles/Category/interfaces';

export default defineComponent({
  name: 'CategoryListView',

  components: { CategoryListTable },

  setup() {
    const { fetch, categories, isLoading, total } = useCategory();

    const { tableOptions, pageOffset } = usePagination();

    async function fetchWrapper() {
      const wrapper = document.querySelector(
        '.base-table-wrapper .v-data-table__wrapper'
      );
      if (wrapper) {
        wrapper.scrollTop = 0;
      }
      const params: any[] = [
        { name: 'skip', value: pageOffset.value },
        { name: 'take', value: tableOptions.value.itemsPerPage },
        { name: 'type', value: 0 }
      ];

      if (activeFilter.value !== null) {
        params.push({
          name: 'active',
          value: activeFilter.value
        });
      }

      await fetch(params);
    }

    const activeFilter = ref<boolean | null>(true);

    watch(
      () => activeFilter,
      () => {
        if (tableOptions.value.page !== 1) {
          tableOptions.value.page = 1;
        } else {
          fetchWrapper();
        }
      },
      { deep: true }
    );

    watch(
      () => tableOptions,
      () => fetchWrapper(),
      { deep: true, immediate: true }
    );

    function optionsChangeEventHandler(options: ITableOptions) {
      tableOptions.value = { ...options };
    }

    function updateCategory(updatedCategory: ICategory) {
      const categoryIndex = categories.value.findIndex(
        category => category.id === updatedCategory.id
      );

      categories.value.splice(categoryIndex, 1, updatedCategory);
    }

    function addCategory(category: ICategory) {
      categories.value.push(category);
    }

    function deleteCategory(id: string) {
      const categoryIndex = categories.value.findIndex(
        category => category.id === +id
      );

      categories.value.splice(categoryIndex, 1);
    }

    return {
      tableOptions,
      categories,
      isLoading,
      total,
      optionsChangeEventHandler,
      fetchWrapper,
      updateCategory,
      addCategory,
      deleteCategory
    };
  }
});
